import React, { useState, useContext, useEffect, useRef } from 'react'
import { /*Table, Switch,*/ Radio, /*Select,*/ Col, Checkbox, Row, Input, /*Button, Space, Tooltip*/ } from 'antd';
import { TokenVerificationLoggedin, ScreenView, Block_U_Admin } from "../../utils/tokenVerify";
// import DownloadOrangeIcon from '../../assets/images/icons/download_csv_icon.svg';
// import FileIcon from '../../assets/images/icons/offcanva_file_icon.svg';
// import deleteIcon from '../../assets/images/icons/trash.svg';
// import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
// import constantData from "../../constants/constantData.json";
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";

const InventorySetting = () => {
    const { TextArea } = Input;
    const loadingContext = useContext(LoadingContext);
    const [/* checkRole */, setCheckRole] = useState("admin")
    const [initialValues, setInitialValues] = useState(null);
    const [isDirty, setIsDirty] = useState(false);

    const [initialPubData, setInitialPubData] = useState(null);

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        Block_U_Admin()


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)


            axios
                .get((configData.SERVER_URL + "ops/getPubDetails?_id="), {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {


                    setInventoryMonetize(response?.data?.data?.inventory_type_select || [])
                    setInventoryMonetizeOther(response?.data?.data?.inventory_type_select_other || "")
                    setInventoryMonetizeWebsiteUserSync(response?.data?.data?.inventory_type_select_website_usersync ?? null)
                    setInventoryMonetizeWebsiteBanner(response?.data?.data?.inventory_type_select_website_bannerPlacement ?? null)

                    setAdFormatMonetize(response?.data?.data?.ad_format_monetise || [])
                    setAdFormatMonetizeOther(response?.data?.data?.ad_format_monetise_other || "")

                    setIntegrationType(response?.data?.data?.integration_type || [])
                    setPrebidQuestion(response?.data?.data?.prebidQuestion || "")
                    setOrtbQuestion(response?.data?.data?.ortbQuestion || "")
                    setOrtbType(response?.data?.data?.ortb_type || [])
                    setVastType(response?.data?.data?.vast_type || [])


                    setIntegrationProtocolPlayer(response?.data?.data?.integration_protocol_player || "")
                    setIntegrationProtocolMime(response?.data?.data?.integration_protocol_mime || "")
                    setIntegrationProtocolTimeout(response?.data?.data?.integration_protocol_timeout || "")
                    setIntegrationProtocolAdserver(response?.data?.data?.integration_protocol_adserver || "")
                    setIntegrationProtocolImpression(response?.data?.data?.integration_protocol_impression ?? null)
                    setIntegrationProtocolBidrequest(response?.data?.data?.integration_protocol_bidrequest || "")
                    setIntegrationProtocolUid(response?.data?.data?.integration_protocol_uid ?? null)
                    setIntegrationProtocolRichMedia(response?.data?.data?.integration_protocol_rich_media ?? null)
                    setIntegrationProtocolRichMediaCreative(response?.data?.data?.integration_protocol_rich_media_creative || [])

                    const apiData = response?.data?.data || {};
                    // setInitialPubData(sanitizePubData(apiData));
                    setInitialPubData(apiData);
                    const initial = {
                        inventoryMonetize: response?.data?.data?.inventory_type_select || [],
                        inventoryMonetizeOther: response?.data?.data?.inventory_type_select_other || "",
                        inventoryMonetizeWebsiteUserSync:
                            response?.data?.data?.inventory_type_select_website_usersync ?? null,
                        inventoryMonetizeWebsiteBanner:
                            response?.data?.data?.inventory_type_select_website_bannerPlacement ?? null,

                        adFormatMonetize: response?.data?.data?.ad_format_monetise || [],
                        adFormatMonetizeOther: response?.data?.data?.ad_format_monetise_other || "",

                        integrationType: response?.data?.data?.integration_type || [],
                        prebidQuestion: response?.data?.data?.prebidQuestion || "",
                        ortbQuestion: response?.data?.data?.ortbQuestion || "",
                        ortbType: response?.data?.data?.ortb_type || [],
                        vastType: response?.data?.data?.vast_type || [],

                        integrationProtocolPlayer:
                            response?.data?.data?.integration_protocol_player || "",
                        integrationProtocolMime:
                            response?.data?.data?.integration_protocol_mime || "",
                        integrationProtocolTimeout:
                            response?.data?.data?.integration_protocol_timeout || "",
                        integrationProtocolAdserver:
                            response?.data?.data?.integration_protocol_adserver || "",
                        integrationProtocolImpression:
                            response?.data?.data?.integration_protocol_impression ?? null,
                        integrationProtocolBidrequest:
                            response?.data?.data?.integration_protocol_bidrequest || "",
                        integrationProtocolUid:
                            response?.data?.data?.integration_protocol_uid ?? null,
                        integrationProtocolRichMedia:
                            response?.data?.data?.integration_protocol_rich_media ?? null,
                        integrationProtocolRichMediaCreative:
                            response?.data?.data?.integration_protocol_rich_media_creative || [],
                    };

                    setInitialValues(initial);

                })
                .catch((error) => {
                    notifyfailure("Failed to fetch the publisher details.")
                });


        }

        loadingContext.done()
    }, [loadingContext]);




    const [buttonValue, setButtonValue] = useState(false);

    const [inventoryMonetize, setInventoryMonetize] = useState([]);
    const [inventoryMonetizeIsRequiredError, setInventoryMonetizeIsRequiredError] = useState(false);
    const [inventoryMonetizeOther, setInventoryMonetizeOther] = useState("");
    const [inventoryMonetizeOtherIsRequiredError, setInventoryMonetizeOtherIsRequiredError] = useState(false);
    const [inventoryMonetizeWebsiteUserSync, setInventoryMonetizeWebsiteUserSync] = useState(null);
    const [inventoryMonetizeWebsiteUserSyncIsRequiredError, setInventoryMonetizeWebsiteUserSyncIsRequiredError] = useState(false);
    const [inventoryMonetizeWebsiteBanner, setInventoryMonetizeWebsiteBanner] = useState(null);
    const [inventoryMonetizeWebsiteBannerIsRequiredError, setInventoryMonetizeWebsiteBannerIsRequiredError] = useState(false);

    const [integrationType, setIntegrationType] = useState([]);
    const [integrationTypeIsRequiredError, setIntegrationTypeIsRequiredError] = useState(false);
    const [prebidQuestion, setPrebidQuestion] = useState("");
    const [prebidQuestionIsRequiredError, setPrebidQuestionIsRequiredError] = useState(false)
    const [ortbType, setOrtbType] = useState([]);
    const [ortbTypeIsRequiredError, setOrtbTypeIsRequiredError] = useState(false);
    const [ortbQuestion, setOrtbQuestion] = useState("");
    const [ortbQuestionIsRequiredError, setOrtbQuestionIsRequiredError] = useState(false)
    const [vastType, setVastType] = useState([]);
    const [vastTypeIsRequiredError, setVastTypeIsRequiredError] = useState(false);

    const [adFormatMonetize, setAdFormatMonetize] = useState([]);
    const [adFormatMonetizeIsRequiredError, setAdFormatMonetizeIsRequiredError] = useState(false);
    const [adFormatMonetizeOther, setAdFormatMonetizeOther] = useState("");
    const [adFormatMonetizeOtherIsRequiredError, setAdFormatMonetizeOtherIsRequiredError] = useState(false);

    const [integrationProtocolPlayer, setIntegrationProtocolPlayer] = useState("");
    const [integrationProtocolMime, setIntegrationProtocolMime] = useState("");
    const [integrationProtocolMimeIsRequiredError, setIntegrationProtocolMimeIsRequiredError] = useState(false);
    const [integrationProtocolTimeout, setIntegrationProtocolTimeout] = useState("");
    const [integrationProtocolAdserver, setIntegrationProtocolAdserver] = useState("");
    const [integrationProtocolImpression, setIntegrationProtocolImpression] = useState(null);
    const [integrationProtocolBidrequest, setIntegrationProtocolBidrequest] = useState("");
    const [integrationProtocolUid, setIntegrationProtocolUid] = useState(null);
    const [integrationProtocolRichMedia, setIntegrationProtocolRichMedia] = useState(null);
    const [integrationProtocolRichMediaIsRequiredError, setIntegrationProtocolRichMediaIsRequiredError] = useState(false);
    const [integrationProtocolRichMediaCreative, setIntegrationProtocolRichMediaCreative] = useState([]);

    const normalizeArray = (arr = []) => [...arr].sort();

    useEffect(() => {
        if (!initialValues) return;

        const hasChanged =
            JSON.stringify(normalizeArray(inventoryMonetize)) !==
            JSON.stringify(normalizeArray(initialValues.inventoryMonetize)) ||
            inventoryMonetizeOther !== initialValues.inventoryMonetizeOther ||
            inventoryMonetizeWebsiteUserSync !==
            initialValues.inventoryMonetizeWebsiteUserSync ||
            inventoryMonetizeWebsiteBanner !==
            initialValues.inventoryMonetizeWebsiteBanner ||

            JSON.stringify(normalizeArray(adFormatMonetize)) !==
            JSON.stringify(normalizeArray(initialValues.adFormatMonetize)) ||
            adFormatMonetizeOther !== initialValues.adFormatMonetizeOther ||

            JSON.stringify(normalizeArray(integrationType)) !==
            JSON.stringify(normalizeArray(initialValues.integrationType)) ||
            prebidQuestion !== initialValues.prebidQuestion ||
            ortbQuestion !== initialValues.ortbQuestion ||
            JSON.stringify(normalizeArray(ortbType)) !==
            JSON.stringify(normalizeArray(initialValues.ortbType)) ||
            JSON.stringify(normalizeArray(vastType)) !==
            JSON.stringify(normalizeArray(initialValues.vastType)) ||

            integrationProtocolPlayer !==
            initialValues.integrationProtocolPlayer ||
            integrationProtocolMime !==
            initialValues.integrationProtocolMime ||
            integrationProtocolTimeout !==
            initialValues.integrationProtocolTimeout ||
            integrationProtocolAdserver !==
            initialValues.integrationProtocolAdserver ||
            integrationProtocolImpression !==
            initialValues.integrationProtocolImpression ||
            integrationProtocolBidrequest !==
            initialValues.integrationProtocolBidrequest ||
            integrationProtocolUid !==
            initialValues.integrationProtocolUid ||
            integrationProtocolRichMedia !==
            initialValues.integrationProtocolRichMedia ||
            JSON.stringify(normalizeArray(integrationProtocolRichMediaCreative)) !==
            JSON.stringify(
                normalizeArray(
                    initialValues.integrationProtocolRichMediaCreative
                )
            );

        setIsDirty(hasChanged);
    }, [
        inventoryMonetize,
        inventoryMonetizeOther,
        inventoryMonetizeWebsiteUserSync,
        inventoryMonetizeWebsiteBanner,
        adFormatMonetize,
        adFormatMonetizeOther,
        integrationType,
        prebidQuestion,
        ortbQuestion,
        ortbType,
        vastType,
        integrationProtocolPlayer,
        integrationProtocolMime,
        integrationProtocolTimeout,
        integrationProtocolAdserver,
        integrationProtocolImpression,
        integrationProtocolBidrequest,
        integrationProtocolUid,
        integrationProtocolRichMedia,
        integrationProtocolRichMediaCreative,
        initialValues
    ]);


    function onChangeInventoryMonetize(event) {
        if (event.length === 0) {
            setInventoryMonetizeIsRequiredError(true)
        }
        else {
            setInventoryMonetizeIsRequiredError(false)
        }
        if (!event.includes("Others")) setInventoryMonetizeOtherIsRequiredError(false);
        setInventoryMonetize(event)
    }

    function onChangeInventoryMonetizeWebsiteUserSync(event) {
        setInventoryMonetizeWebsiteUserSyncIsRequiredError(false)
        setInventoryMonetizeWebsiteUserSync(event.target.value);
    }

    function onChangeInventoryMonetizeWebsiteBanner(event) {
        setInventoryMonetizeWebsiteBannerIsRequiredError(false)
        setInventoryMonetizeWebsiteBanner(event.target.value);
    }


    function onChangeAdFormatMonetize(event) {
        if (event.length === 0) {
            setAdFormatMonetizeIsRequiredError(true)
        }
        else {
            setAdFormatMonetizeIsRequiredError(false)
        }
        if (!event.includes("Others")) setAdFormatMonetizeOtherIsRequiredError(false);
        setAdFormatMonetize(event)
    }

    function onChangeIntegrationType(event) {
        if (event.length > 0) {
            setIntegrationTypeIsRequiredError(false)
        }
        else {
            setIntegrationTypeIsRequiredError(true)
        }
        setIntegrationType(event)
    }

    function onChangePrebidQuestion(event) {
        setPrebidQuestionIsRequiredError(false);
        setPrebidQuestion(event.target.value);
    }

    function onBlurPrebidQuestion(event) {
        if (event.target.value.trim().length === 0) {
            setPrebidQuestionIsRequiredError(true);
        }
        setPrebidQuestion(event.target.value.trim());
    }

    function onChangeOrtbType(event) {
        setOrtbType(event)
        if (event?.length === 0) {
            setOrtbTypeIsRequiredError(true)
        }
        else {
            setOrtbTypeIsRequiredError(false)
        }
    }

    function onChangeOrtbQuestion(event) {
        setOrtbQuestionIsRequiredError(false);
        setOrtbQuestion(event.target.value);
    }

    function onBlurOrtbQuestion(event) {
        if (event.target.value.trim().length === 0) {
            setOrtbQuestionIsRequiredError(true);
        }
        setOrtbQuestion(event.target.value.trim());
    }

    function onChangeVastType(event) {
        setVastType(event)
        if (event?.length === 0) {
            setVastTypeIsRequiredError(true)
        }
        else {
            setVastTypeIsRequiredError(false)
        }
    }


    function onChangeIntegrationProtocolPlayer(event) {
        setIntegrationProtocolPlayer(event.target.value);
    }

    function onBlurIntegrationProtocolPlayer(event) {
        setIntegrationProtocolPlayer(event.target.value.trim());
    }

    function onChangeIntegrationProtocolMime(event) {
        setIntegrationProtocolMimeIsRequiredError(false);
        setIntegrationProtocolMime(event.target.value);
    }

    function onBlurIntegrationProtocolMime(event) {
        if (event.target.value.trim().length === 0) {
            setIntegrationProtocolMimeIsRequiredError(true);
        }
        setIntegrationProtocolMime(event.target.value.trim());
    }


    function onChangeIntegrationProtocolTimeout(event) {
        setIntegrationProtocolTimeout(event.target.value);
    }

    function onBlurIntegrationProtocolTimeout(event) {
        setIntegrationProtocolTimeout(event.target.value.trim());
    }

    function onChangeIntegrationProtocolAdserver(event) {
        setIntegrationProtocolAdserver(event.target.value);
    }

    function onChangeIntegrationProtocolImpression(event) {
        setIntegrationProtocolImpression(event.target.value);
    }

    function onBlurIntegrationProtocolAdserver(event) {
        setIntegrationProtocolAdserver(event.target.value.trim());
    }

    function onChangeIntegrationProtocolBidrequest(event) {
        setIntegrationProtocolBidrequest(event.target.value);
    }

    function onChangeIntegrationProtocolUid(event) {
        setIntegrationProtocolUid(event.target.value);
    }

    function onBlurIntegrationProtocolBidrequest(event) {
        setIntegrationProtocolBidrequest(event.target.value.trim());
    }

    function onChangeIntegrationProtocolRichMedia(event) {
        setIntegrationProtocolRichMediaIsRequiredError(false)
        setIntegrationProtocolRichMedia(event.target.value);
    }

    function onChangeIntegrationProtocolRichMediaCreative(event) {
        setIntegrationProtocolRichMediaCreative(event)
    }

    // --- duplicate function declarations below (originals defined above) ---
    // function onChangeAdFormatMonetize(event) { ... }
    // function onChangeIntegrationType(event) { ... }
    // function onChangePrebidQuestion(event) { ... }
    // function onBlurPrebidQuestion(event) { ... }
    // function onChangeOrtbType(event) { ... }
    // function onChangeOrtbQuestion(event) { ... }
    // function onBlurOrtbQuestion(event) { ... }
    // function onChangeVastType(event) { ... }
    // function onChangeIntegrationProtocolPlayer(event) { ... }
    // function onBlurIntegrationProtocolPlayer(event) { ... }
    // function onChangeIntegrationProtocolMime(event) { ... }
    // function onBlurIntegrationProtocolMime(event) { ... }
    // function onChangeIntegrationProtocolTimeout(event) { ... }
    // function onBlurIntegrationProtocolTimeout(event) { ... }
    // function onChangeIntegrationProtocolAdserver(event) { ... }
    // function onChangeIntegrationProtocolImpression(event) { ... }
    // function onBlurIntegrationProtocolAdserver(event) { ... }
    // function onChangeIntegrationProtocolBidrequest(event) { ... }
    // function onChangeIntegrationProtocolUid(event) { ... }
    // function onBlurIntegrationProtocolBidrequest(event) { ... }
    // function onChangeIntegrationProtocolRichMedia(event) { ... }
    // function onChangeIntegrationProtocolRichMediaCreative(event) { ... }
    // --- end duplicate block ---

    const objectToFormData = (obj) => {
        const formData = new FormData();

        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        return formData;
    };


    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 0);
        }
    };

    const inventoryMonetizeRef = useRef(null)
    const adFormatMonetizeRef = useRef(null)
    const integrationTypeRef = useRef(null)
    const integrationProtocolDetailsRef = useRef(null)

    const errorDetect = () => {


        if (inventoryMonetize.length === 0 || inventoryMonetizeIsRequiredError ||
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSync === null : false) ||
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBanner === null : false) ||
            (inventoryMonetize.includes("Others") ? inventoryMonetizeOther.trim() === "" : false)
        ) {
            scrollToItem(inventoryMonetizeRef);
            return
        }

        if (adFormatMonetize.length === 0 || adFormatMonetizeIsRequiredError ||
            (adFormatMonetize.includes("Others") ? adFormatMonetizeOther.trim() === "" : false)
        ) {
            scrollToItem(adFormatMonetizeRef);
            return
        }

        if (
            integrationType.length === 0 || integrationTypeIsRequiredError ||
            (integrationType.includes("Prebid") && (prebidQuestion.trim() === "" || prebidQuestionIsRequiredError)) ||
            (integrationType.includes("ORTB") && (ortbType.length === 0 || ortbTypeIsRequiredError || ortbQuestion.trim() === "" || ortbQuestionIsRequiredError)) ||
            (integrationType.includes("VAST") && (vastType.length === 0 || vastTypeIsRequiredError))

        ) {
            scrollToItem(integrationTypeRef);
            return
        }

        if (integrationProtocolMime === "" || integrationProtocolMimeIsRequiredError || integrationProtocolRichMedia === null || integrationProtocolRichMediaIsRequiredError) {
            scrollToItem(integrationProtocolDetailsRef);
            return
        }

    }


    const buildFinalPayload = () => {
        if (!initialPubData) return null;

        return {
            ...initialPubData, // ✅ ALL keys preserved

            // 🔥formatted keys
            im: JSON.stringify(initialPubData.im),
            defineYourself: JSON.stringify(initialPubData.defineYourself),
            // inventory_type_select: JSON.stringify(initialPubData.inventory_type_select), // overridden below
            // ad_format_monetise: JSON.stringify(initialPubData.ad_format_monetise), // overridden below
            // ad_format_monetise_other: JSON.stringify(initialPubData.ad_format_monetise_other), // overridden below
            // integration_type: JSON.stringify(initialPubData.integration_type), // overridden below
            // ortb_type: JSON.stringify(initialPubData.ortb_type), // overridden below
            // vast_type: JSON.stringify(initialPubData.vast_type), // overridden below
            // integration_protocol_rich_media_creative: JSON.stringify(initialPubData.integration_protocol_rich_media_creative), // overridden below
            blockCategory: JSON.stringify(initialPubData.blockCategory),
            bcate_data: JSON.stringify(initialPubData.bcate_data),

            inventoryWebsiteData: initialPubData.inventory_type_select.includes("Website") ? JSON.stringify(initialPubData.inventoryWebsiteData) : [],
            inventoryMobileData: initialPubData.inventory_type_select.includes("Mobile App (Android / iOS)") ? JSON.stringify(initialPubData.inventoryMobileData) : [],
            inventoryCtvData: initialPubData.inventory_type_select.includes("CTV / FAST Apps") ? JSON.stringify(initialPubData.inventoryCtvData) : [],

            //keys to replace / update

            inventory_type_select: JSON.stringify(inventoryMonetize),
            inventory_type_select_other: inventoryMonetizeOther,
            inventory_type_select_website_usersync: inventoryMonetizeWebsiteUserSync,
            inventory_type_select_website_bannerPlacement: inventoryMonetizeWebsiteBanner,

            ad_format_monetise: JSON.stringify(adFormatMonetize),
            ad_format_monetise_other: JSON.stringify(adFormatMonetizeOther),

            integration_type: JSON.stringify(integrationType),
            prebidQuestion: prebidQuestion,
            ortbQuestion: ortbQuestion,
            ortb_type: JSON.stringify(ortbType),
            vast_type: JSON.stringify(vastType),

            integration_protocol_player: integrationProtocolPlayer,
            integration_protocol_mime: integrationProtocolMime,
            integration_protocol_timeout: integrationProtocolTimeout,
            integration_protocol_adserver: integrationProtocolAdserver,
            integration_protocol_impression: integrationProtocolImpression,
            integration_protocol_bidrequest: integrationProtocolBidrequest,
            integration_protocol_uid: integrationProtocolUid,
            integration_protocol_rich_media: integrationProtocolRichMedia,
            integration_protocol_rich_media_creative: JSON.stringify(integrationProtocolRichMediaCreative)

        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        errorDetect()
        if (

            inventoryMonetize.length !== 0 &&
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSync !== null : true) &&
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBanner !== null : true) &&
            (inventoryMonetize.includes("Others") ? inventoryMonetizeOther.trim() !== "" : true) &&
            adFormatMonetize.length !== 0 &&
            (adFormatMonetize.includes("Others") ? adFormatMonetizeOther.trim() !== "" : true) &&
            integrationType.length !== 0 &&
            ((integrationType.includes("Prebid")) ? prebidQuestion !== "" : true) &&
            ((integrationType.includes("ORTB")) ? ortbQuestion !== "" : true) &&
            ((integrationType.includes("ORTB")) ? ortbType.length > 0 : true) &&
            ((integrationType.includes("VAST")) ? vastType.length > 0 : true) &&
            integrationProtocolMime !== "" &&
            integrationProtocolRichMedia !== null

        ) {
            if (
                inventoryMonetizeIsRequiredError === false &&
                (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSyncIsRequiredError === false : true) &&
                (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBannerIsRequiredError === false : true) &&
                (inventoryMonetize.includes("Others") ? inventoryMonetizeOtherIsRequiredError === false : true) &&
                adFormatMonetizeIsRequiredError === false &&
                (adFormatMonetize.includes("Others") ? adFormatMonetizeOtherIsRequiredError === false : true) &&
                integrationTypeIsRequiredError === false &&
                ((integrationType.includes("Prebid")) ? prebidQuestionIsRequiredError === false : true) &&
                ((integrationType.includes("ORTB")) ? ortbQuestionIsRequiredError === false : true) &&
                ((integrationType.includes("ORTB")) ? ortbTypeIsRequiredError === false : true) &&
                ((integrationType.includes("VAST")) ? vastTypeIsRequiredError === false : true) &&
                integrationProtocolMimeIsRequiredError === false &&
                integrationProtocolRichMediaIsRequiredError === false
            ) {

                const finalPayload = buildFinalPayload();
                if (!finalPayload) return;

                const formData = objectToFormData(finalPayload);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                window.location.reload()
                            }, 1500)


                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });

                }





            }
        } else {

            if (inventoryMonetize.length === 0) {
                setInventoryMonetizeIsRequiredError(true);
            }

            if (inventoryMonetize.includes("Website") && inventoryMonetizeWebsiteUserSync === null) {
                setInventoryMonetizeWebsiteUserSyncIsRequiredError(true);
            }

            if (inventoryMonetize.includes("Website") && inventoryMonetizeWebsiteBanner === null) {
                setInventoryMonetizeWebsiteBannerIsRequiredError(true);
            }

            if (inventoryMonetize.includes("Others") && inventoryMonetizeOther.trim() === "") {
                setInventoryMonetizeOtherIsRequiredError(true);
            }

            if (adFormatMonetize.length === 0) {
                setAdFormatMonetizeIsRequiredError(true);
            }

            if (adFormatMonetize.includes("Others") && adFormatMonetizeOther.trim() === "") {
                setAdFormatMonetizeOtherIsRequiredError(true);
            }

            if (integrationType.length === 0) {
                setIntegrationTypeIsRequiredError(true)
            }

            if (integrationType.includes("Prebid") && prebidQuestion === "") {
                setPrebidQuestionIsRequiredError(true)
            }

            if (integrationType.includes("ORTB") && ortbQuestion === "") {
                setOrtbQuestionIsRequiredError(true)
            }

            if (integrationType.includes("ORTB") && ortbType.length === 0) {
                setOrtbTypeIsRequiredError(true)
            }

            if (integrationType.includes("VAST") && vastType.length === 0) {
                setVastTypeIsRequiredError(true)
            }

            if (integrationProtocolMime === "") {
                setIntegrationProtocolMimeIsRequiredError(true);
            }

            if (integrationProtocolRichMedia === null) {
                setIntegrationProtocolRichMediaIsRequiredError(true);
            }

        }
    };





    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between">
                <h1 className="heading fw_600"> Inventory Settings </h1>
                {!buttonValue ?
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 4rem' }} onClick={handleSubmit} disabled={!isDirty}>
                        <span>
                            Save
                        </span>
                    </button>
                    :
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 3rem' }}>
                        <span>
                            Processing...
                        </span>
                    </button>
                }
            </div>

            <div className="container_box--form-container bg-transparent border-0 p-0">
                <div className="container_box--width">

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>What kind of inventory do you want to monetize with us? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container"
                                ref={inventoryMonetizeRef}
                            >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={inventoryMonetize}
                                                    onChange={onChangeInventoryMonetize}
                                                // disabled={isDisabled}
                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="CTV / FAST Apps">
                                                        CTV / FAST Apps
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Mobile App (Android / iOS)">
                                                        Mobile App (Android / iOS)
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Website">
                                                        Website
                                                    </Checkbox>
                                                    <Checkbox className={inventoryMonetize.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"} value="Others">
                                                        Others

                                                        <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                            disabled={(!inventoryMonetize.includes("Others"))}
                                                            value={inventoryMonetize.includes("Others") ? inventoryMonetizeOther : ""}
                                                            onChange={(e) => {
                                                                setInventoryMonetizeOther(e.target.value);
                                                                if (e.target.value.trim().length > 0) setInventoryMonetizeOtherIsRequiredError(false);
                                                            }}
                                                        />

                                                    </Checkbox>
                                                    {inventoryMonetize.includes("Others") && inventoryMonetizeOtherIsRequiredError && (
                                                        <span className="error_content">Please provide value for others</span>
                                                    )}
                                                </Checkbox.Group>
                                                {inventoryMonetizeIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    {inventoryMonetize.includes("Website") &&
                                        <>
                                            <Col span={24}>
                                                <hr className='divider_line' />
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group">
                                                    <div className=''>
                                                        <label className="form_label">Do you support User Syncing on websites?</label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={inventoryMonetizeWebsiteUserSync}
                                                            onChange={onChangeInventoryMonetizeWebsiteUserSync}
                                                        // disabled={isDisabled}
                                                        >
                                                            <Radio className='radio_btn w-auto' value={true}>Yes</Radio>
                                                            <Radio className='radio_btn w-auto' value={false}>No</Radio>
                                                        </Radio.Group>
                                                        {inventoryMonetizeWebsiteUserSyncIsRequiredError && (
                                                            <span className="error_content">This field is required</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb-0">
                                                    <div className=''>
                                                        <label className="form_label">Do you allow Outstream video (IBV) over banner placements? (Website)</label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={inventoryMonetizeWebsiteBanner}
                                                            onChange={onChangeInventoryMonetizeWebsiteBanner}
                                                        // disabled={isDisabled}
                                                        >
                                                            <Radio className='radio_btn w-auto' value={true}>Yes</Radio>
                                                            <Radio className='radio_btn w-auto' value={false}>No</Radio>
                                                        </Radio.Group>
                                                        {inventoryMonetizeWebsiteBannerIsRequiredError && (
                                                            <span className="error_content">This field is required</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    }

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>What ad formats do you want to monetize? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container"
                                ref={adFormatMonetizeRef}
                            >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={adFormatMonetize}
                                                    onChange={onChangeAdFormatMonetize}
                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="Instream Video">
                                                        Instream Video
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Outstream / In-Article Video">
                                                        Outstream / In-Article Video
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Rewarded Video">
                                                        Rewarded Video
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Banner (Display)">
                                                        Banner (Display)
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Native">
                                                        Native
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Pause Ads">
                                                        Pause Ads
                                                    </Checkbox>
                                                    <Checkbox className={adFormatMonetize.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"}
                                                        value="Others">
                                                        Others
                                                        <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                            disabled={(!adFormatMonetize.includes("Others"))}
                                                            value={adFormatMonetize.includes("Others") ? adFormatMonetizeOther : ""}
                                                            onChange={(e) => {
                                                                setAdFormatMonetizeOther(e.target.value);
                                                                if (e.target.value.trim().length > 0) setAdFormatMonetizeOtherIsRequiredError(false);
                                                            }}
                                                        />
                                                    </Checkbox>
                                                    {adFormatMonetize.includes("Others") && adFormatMonetizeOtherIsRequiredError && (
                                                        <span className="error_content">Please provide value for others</span>
                                                    )}
                                                </Checkbox.Group>
                                                {adFormatMonetizeIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Preferred Integration Method *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container"
                                ref={integrationTypeRef}
                            >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <Checkbox.Group className="form_checkbox equal_space"
                                                value={integrationType} onChange={onChangeIntegrationType}
                                            // disabled={isDisabled}
                                            >
                                                <Checkbox className="checkbox_btn w-100" value="Prebid">
                                                    Prebid
                                                </Checkbox>

                                                {integrationType.includes("Prebid") &&
                                                    <>

                                                        <Col span={24}>
                                                            <div className="form_content_block--group hide_caret_after_select_value mb-0 mt-3">
                                                                <label className="form_label">If you support header bidding, please specify the solution used. (e.g., Prebid.js, Amazon, PubMatic OpenWrap, etc) * </label>
                                                                <TextArea className={prebidQuestionIsRequiredError ? 'form_control error basic form_control_h --80 textarea_paddingY_d2' : 'form_control  basic form_control_h --80 textarea_paddingY_d2'} autoComplete="off"
                                                                    autoSize={{ minRows: 3, maxRows: 5, }}
                                                                    value={prebidQuestion}
                                                                    onChange={onChangePrebidQuestion}
                                                                    onBlur={onBlurPrebidQuestion}
                                                                // disabled={isDisabled}
                                                                />

                                                                <span className="error_content">
                                                                    {
                                                                        prebidQuestionIsRequiredError &&
                                                                        <>This field is requied</>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <hr className="divider_line" />
                                                        </Col>
                                                    </>
                                                }
                                                <Checkbox className="checkbox_btn w-100" value="ORTB">
                                                    ORTB
                                                </Checkbox>
                                                {integrationType.includes("ORTB") &&
                                                    <>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group mb-0 mt-3">
                                                                <label className="form_label">If your setup supports OpenRTB, please specify the version. (e.g., 2.3, 2.5, 2.6, etc) *</label>
                                                                <Input className={ortbQuestionIsRequiredError ? 'form_control basic error' : 'form_control  basic'} placeholder='Enter version' autoComplete="off"
                                                                    value={ortbQuestion}
                                                                    onChange={onChangeOrtbQuestion}
                                                                    onBlur={onBlurOrtbQuestion}
                                                                // disabled={isDisabled}
                                                                />

                                                                <span className="error_content">
                                                                    {
                                                                        ortbQuestionIsRequiredError &&
                                                                        <>This field is requied</>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group mb-0">
                                                                <label className="form_label">Select the impression counting method you support. * </label>
                                                                <Checkbox.Group className="form_checkbox equal_space"
                                                                    value={ortbType} onChange={onChangeOrtbType}
                                                                // disabled={isDisabled}
                                                                >
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="ADM">
                                                                        ADM
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="NURL">
                                                                        NURL
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="BURL">
                                                                        BURL
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                                <span className='error_content'>
                                                                    {ortbTypeIsRequiredError && <> Minimum 1 selection is required</>}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <hr className="divider_line" />
                                                        </Col>
                                                    </>
                                                }
                                                <Checkbox className="checkbox_btn w-100" value="VAST">
                                                    VAST
                                                </Checkbox>

                                                {integrationType.includes("VAST") &&
                                                    <>

                                                        <Col span={24}>
                                                            <div className="form_content_block--group mb-0 mt-3">
                                                                <label className="form_label">Select the supported VAST Version * </label>
                                                                <Checkbox.Group className="form_checkbox equal_space"
                                                                    value={vastType} onChange={onChangeVastType}
                                                                // disabled={isDisabled}
                                                                >
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="VAST VERSION 2.0">
                                                                        VAST VERSION 2.0
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="VAST VERSION 3.0">
                                                                        VAST VERSION 3.0
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="VAST VERSION 4.0">
                                                                        VAST VERSION 4.0
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            <span className="error_content">
                                                                {vastTypeIsRequiredError && <> Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </>
                                                }
                                            </Checkbox.Group>

                                            <span className='error_content'>
                                                {integrationTypeIsRequiredError &&
                                                    <>This field is required</>
                                                }
                                            </span>

                                        </div>
                                    </Col>





                                </Row>
                            </div>
                        </Col>
                    </Row>


                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Integration & Protocol Support</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container"
                                ref={integrationProtocolDetailsRef}
                            >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which Player/SDK Used for Video Inventory?</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolPlayer}
                                                onBlur={onBlurIntegrationProtocolPlayer}
                                                onChange={onChangeIntegrationProtocolPlayer}
                                            // disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">List the MIME types your ad placements support. (e.g., video/mp4, application/javascript, text/html) *</label>
                                            <Input
                                                className={
                                                    integrationProtocolMimeIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={integrationProtocolMime}
                                                onBlur={onBlurIntegrationProtocolMime}
                                                onChange={onChangeIntegrationProtocolMime}
                                                autocomplete="off"
                                            // disabled={isDisabled}
                                            />
                                            <span className='error_content'>
                                                {integrationProtocolMimeIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Please specify your maximum timeout (Tmax) in milliseconds. (This is the time you allow for a bid response)</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolTimeout}
                                                onBlur={onBlurIntegrationProtocolTimeout}
                                                onChange={onChangeIntegrationProtocolTimeout}
                                            // disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Please specify where your ad servers are hosted. (e.g., AWS US-East, GCP Europe,etc)</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolAdserver}
                                                onBlur={onBlurIntegrationProtocolAdserver}
                                                onChange={onChangeIntegrationProtocolAdserver}
                                            // disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <div className=''>
                                                <label className="form_label">Do you support multiple impressions in a single request</label>
                                                <Radio.Group className="form_radio equal_space"
                                                    // disabled={isDisabled}
                                                    onChange={onChangeIntegrationProtocolImpression}
                                                    value={integrationProtocolImpression}
                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIntegrationProtocolImpression}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIntegrationProtocolImpression}>No</Radio>
                                                </Radio.Group>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Do your bid requests include content-level parameters such as channel, genre, language, or content rating?</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolBidrequest}
                                                onBlur={onBlurIntegrationProtocolBidrequest}
                                                onChange={onChangeIntegrationProtocolBidrequest}
                                            // disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <div className=''>
                                                <label className="form_label">Can you pass buyer uid and uid in requests?</label>
                                                <Radio.Group className="form_radio equal_space"
                                                    // disabled={isDisabled}
                                                    onChange={onChangeIntegrationProtocolUid}
                                                    value={integrationProtocolUid}
                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIntegrationProtocolUid}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIntegrationProtocolUid}>No</Radio>
                                                </Radio.Group>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className={integrationProtocolRichMedia ? "form_content_block--group" : "form_content_block--group mb-0"}>
                                            <div className=''>
                                                <label className="form_label">Do you support Rich Media creatives? *</label>
                                                <Radio.Group className="form_radio equal_space"
                                                    onChange={onChangeIntegrationProtocolRichMedia} value={integrationProtocolRichMedia}
                                                // disabled={isDisabled}
                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIntegrationProtocolRichMedia}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIntegrationProtocolRichMedia}>No</Radio>
                                                </Radio.Group>
                                                <span className="error_content">
                                                    {integrationProtocolRichMediaIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    {integrationProtocolRichMedia &&
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">Select supported Rich Media creatives</label>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={integrationProtocolRichMediaCreative}
                                                    onChange={onChangeIntegrationProtocolRichMediaCreative}
                                                // disabled={isDisabled}

                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="MRAID">
                                                        MRAID
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="HTML">
                                                        HTML
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Expandable">
                                                        Expandable
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="JS">
                                                        JS
                                                    </Checkbox>
                                                </Checkbox.Group>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default InventorySetting;
